import React from 'react';
import { Link as RouterLink, useRouteMatch, useLocation } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import { Box, Button, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ProductTable } from '../../modules';
import { Method } from '../../routePaths';
import { PaddedContainer } from '../../ui-kit';

const ProductsListView = () => {
    const { url } = useRouteMatch();
    const location = useLocation();
    const referrer = `${location.pathname}${location.search}`;
    const { t } = useTranslation();

    return (
        <PaddedContainer spacing={3}>
            <Grid item xs={12}>
                <Box mb={2} display="flex" justifyContent="flex-end">
                    <Button
                        startIcon={<AddIcon />}
                        component={RouterLink}
                        to={{ pathname: `${url}${Method.CREATE}`, state: { referrer } }}
                        variant="contained"
                        color="primary"
                    >
                        {t('New product')}
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <ProductTable />
            </Grid>
        </PaddedContainer>
    );
};

export default ProductsListView;
